/**
 * The delivery code.
 *
 * Eight digits, matching the server (App\Services\DeliveryCode::LENGTH). It
 * releases a merchant's payment, so it carries more weight than a login OTP —
 * 100 million combinations rather than a million — and the recipient reads it
 * once from WhatsApp rather than typing it repeatedly.
 *
 * Kept in one place because the length is enforced at three UI points (the
 * recipient's confirm card, the merchant's at-door entry, and the input caps)
 * and they had already drifted apart once: both submitted at 4 characters
 * while capping at 6, so a half-typed code reached the server and came back
 * "incorrect" — which reads as "your code is wrong", not "keep typing".
 */
export const DELIVERY_CODE_LENGTH = 8;

/** Digits only, capped at the code length. */
export function normaliseDeliveryCode(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, DELIVERY_CODE_LENGTH);
}

/** Only a complete code may be submitted. */
export function isCompleteDeliveryCode(value: string): boolean {
  return value.length === DELIVERY_CODE_LENGTH;
}
